import { render, staticRenderFns } from "./replylateremaildetails.vue?vue&type=template&id=10fc6f88&"
import script from "./replylateremaildetails.vue?vue&type=script&lang=js&"
export * from "./replylateremaildetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports